import Vue from "vue";

import yearPlan from "./yearPlan.vue";
import monthPlan from "./monthPlan.vue";
import teacherAudit from "./teacherAudit.vue";
import trainNeedsAudit from "./trainNeedsAudit.vue";
import attendanceLeaveAudit from "./attendanceLeaveAudit.vue";
import trainClassAudit from "./trainClassAudit.vue";
import classRoomAudit from "./classRoomAudit.vue";
import userTeacherAudit from "./userTeacherAudit.vue";
import hourCreditIntegralAudit from "./hourCreditIntegralAudit.vue";
import trainClassActionPlanSubmit from "./trainClassActionPlanSubmit.vue";
import publishOnlineCourse from "./publishOnlineCourseAudit.vue";

Vue.component("yearPlan", yearPlan);
Vue.component("monthPlan", monthPlan);
Vue.component("teacherAudit", teacherAudit);
Vue.component("trainNeedsAudit", trainNeedsAudit);
Vue.component("attendanceLeaveAudit", attendanceLeaveAudit);
Vue.component("trainClassAudit", trainClassAudit);
Vue.component("classRoomAudit", classRoomAudit);
Vue.component("userTeacherAudit", userTeacherAudit);
Vue.component("hourCreditIntegralAudit", hourCreditIntegralAudit);
Vue.component("trainClassActionPlanSubmit", trainClassActionPlanSubmit);
Vue.component("publishOnlineCourse", publishOnlineCourse);



// WEBPACK FOOTER //
// ./src/shared/views/register.js